import { useState } from 'react';
import LogIn from './Login';
import Signup from './Signup';

const Authentication = () => {
  const [isLogin, setIsLogin] = useState(true);
  return (
    <>
      {isLogin ? (
        <LogIn setIsLogin={setIsLogin} />
      ) : (
        <Signup setIsLogin={setIsLogin} />
      )}
    </>
  );
};

export default Authentication;
